/**************************************************
 * Nombre:       Dialogo_Despacho
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid2} from "@mui/material";
import {useFormulario} from "../../Modulo_formularios/Hooks/useFormulario";
import {useAvisos} from "../../Modulo_Avisos/Hooks/useAvisos";
import {useLoaders} from "../../Modulo_Loaders/Hooks/useLoaders";
import logo from '../../Recursos/logo_redondo.svg'
import {guardarDoc} from "../../Servicios/BD/guardarDoc";
import {Delete} from "@mui/icons-material";
import {borrarDoc} from "../../Servicios/BD/borrarDoc";
import Formulario_Categoria from "../Formularios/Formulario_Categoria";
import {useEffect, useState} from "react";
import {obtenerCol} from "../../Servicios/BD/obtenerCol";
import Tarjeta_Sub_Categorias from "../Tarjetas/Tarjeta_Sub_Categorias";
import {ordernarPor} from "../../Utilidades/ordernarPor";
import {subirImagenHostingFile} from "../../Servicios/AlmacenamientoHosting/subirImagenHostingFile";

const Dialogo_Categorias = ({datos, cerrar, realizado}) => {
    const {props, obtenerEntidad} = useFormulario({valoresDefecto: datos})
    const {Cargador, abrirCargador, setDetener} = useLoaders({logo: logo})
    const [subCategorias, setSubCategorias] = useState([])
    const [subCatSelec, setSubCatSelec] = useState([])
    const {Avisos, nuevoAviso, terminar} = useAvisos({funcionUno: cerrar, funcionDos: realizado})


    const subirDatos = async () => {


        let entidad = await obtenerEntidad()
        entidad.fecha = new Date().getTime()

        abrirCargador('Guardando Datos')

        let doxImg = await subirImagenHostingFile(entidad.img)
        entidad.img = doxImg.data

        let dox = await guardarDoc('categorias', entidad)
        setDetener(false)
        if (dox.res) {
            terminar({aviso: 'Datos subidos con exito'})
        } else {
            terminar({aviso: 'Algo salio mal, por favor intentalo nuevamente', variante: 'error'})
        }

    }



    const borrarCat = (index) => {

        let arr = subCatSelec
        arr.splice(index, 1)
        console.log(arr)
        setSubCatSelec(arr)

    }

    const borrar = async () => {
        await borrarDoc('categorias', datos.id)
        //borrar categoria de productos
        terminar({aviso: 'Categoria borrada'})
    }

    return (
        <Grid2
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{p: 1}}
        >

            <Avisos/>

            <Cargador/>

            <Grid2 container size={{xs: 12, sm: 12, md: 12}}>
                <Formulario_Categoria props={props}  />
            </Grid2>

            <Grid2 container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 2}}>
                {subCatSelec.map((it, index) => {
                    return (
                        <Tarjeta_Sub_Categorias categorias={subCatSelec} item={it} index={index} borrar={borrarCat}/>
                    )
                })}
            </Grid2>

            <Grid2 container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', marginTop: 3}}>
                <Button
                    onClick={() => subirDatos()}
                >Guardar Datos</Button>
            </Grid2>

            {datos && datos.id &&
                <Grid2 container size={{xs: 12, sm: 12, md: 12}}>
                    <Button
                        onClick={() => borrar()}
                        color={'success'} startIcon={<Delete/>} variant={'text'}>
                        Borrar
                    </Button>
                </Grid2>
            }


        </Grid2>
    )

}
export default Dialogo_Categorias